<template>
  <div class="columns my-0 is-multiline">
    <div class="column is-3">
      <kst-input floating-label load-on-focus
        field="Search" :data="searchData" :catalog="StopSearchCatalog"
        @input="handleInput"
      />
    </div>
    <div class="column is-narrow">
      <kst-input floating-label
        field="WarehouseID" :data="searchData" :catalog="StopSearchCatalog"
        :options="warehouseOptions" @input="handleInput"
      />
    </div>
    <div class="column is-narrow">
      <kst-input floating-label
        field="Date" :data="searchData" :catalog="StopSearchCatalog"
        @input="handleInput"
      />
    </div>
  </div>
</template>

<script>
import StopSearchCatalog from "../StopSearchCatalog.js";

export default {
  props: {
    searchData: Object,
    warehouseOptions: Object,
  },
  data: () => ({
    StopSearchCatalog: StopSearchCatalog
  }),
  methods: {
    handleInput() {
      this.$emit(this.$kst.Enum.Event.Input);
    }
  }
}
</script>